import { createComponentStore } from '../createComponentStore';
export const usePositionsInfoComponentStore = createComponentStore('positionsInfoComponentStore');
